import {combineEpics, ofType, OTPDialogActions, PledgerEpic} from "@pledger/frontend-commons";
import {AppActions} from "../app/AppActions";
import {EnrollmentActions} from "./EnrollmentActions";
import {enrollmentWServiceActions} from "../../services/ws/enrollment/enrollmentWServiceActions";
import {map} from "rxjs/operators";
import {EnrollmentStatusCode} from "../../services/ws/enrollmentToken/dto/EnrollmentStatusCode";
import {ShowPageActions} from "../app/Pages/ShowPageActions";
import {WServiceActions} from "../../services/ws/WServiceActions";

/*const emptyEpic : PledgerEpic<any> = (actions$ : Observable<PledgerAction>) => of(AppActions.EMPTY_ACTION.build());*/

const enrollmentLoadedEpic : PledgerEpic<any> = (actions$ ) =>
    actions$.pipe(
        ofType(EnrollmentActions.ENROLLMENT_LOADED_ACTION.type),
        map((action) => {
            return enrollmentWServiceActions.GET_ENROLLMENT_STATE_ACTION.build();
        })
    );

const phoneRegisteredEpic : PledgerEpic<any> = (actions$, state$ ) =>
    actions$.pipe(
        ofType(enrollmentWServiceActions.REGISTER_IDENTITY_SUCCEEDED_ACTION.type),
        map((action) => {
            const appContext = state$.value.appContext;
            const customColors = appContext.customColors;
            return OTPDialogActions.SHOW_OTP_DIALOG_ACTION.build(action.payload.data.phoneNumber,
                action.payload.data.partialPhoneNumber,
                'Validez votre numéro de téléphone',
                enrollmentWServiceActions.PHONE_NUMBER_VALIDATION_ACTION.build,
                WServiceActions.REQUEST_SMS_CODE_ACTION.build,
                customColors.PLEDGER_GREEN_COLOR,
                customColors.PLEDGER_ORANGE_COLOR,
                customColors.PLEDGER_START_GRADIENT_COLOR,
                customColors.PLEDGER_END_GRADIENT_COLOR,
                customColors.PLEDGER_GREEN_SHADOW_COLOR
            );
        })
    );

const phoneValidatedEpic : PledgerEpic<any> = (actions$ ) =>
    actions$.pipe(
        ofType(enrollmentWServiceActions.PHONE_NUMBER_VALIDATION_SUCCEEDED_ACTION.type),
        map((action) => {
            return OTPDialogActions.CLOSE_OTP_DIALOG_ACTION.build();
        })
    );

const accountCreatedEpic : PledgerEpic<any> = (actions$ ) =>
    actions$.pipe(
        ofType(enrollmentWServiceActions.CREATE_ACCOUNT_SUCCEEDED_ACTION.type),
        map((action) => {
            if(action.payload.data.enrollmentStatus === EnrollmentStatusCode.FINISHED) {
                return ShowPageActions.SHOW_HOME_ACTION.build(false);
            }
            return AppActions.EMPTY_ACTION.build();
        })
    );

export const enrollmentEpics = combineEpics(
    enrollmentLoadedEpic,
    phoneRegisteredEpic,
    phoneValidatedEpic,
    accountCreatedEpic
);
